export function hasMultiConditions(step) {
    return ('conditions' in step && !!step.conditions && 'rules' in step.conditions);
}
